import { useQuery } from '@tanstack/react-query';
import { getStaleOrders, getStaleOrdersDates } from '../api/client';

export function useStaleOrdersDates() {
  return useQuery({
    queryKey: ['stale-orders-dates'],
    queryFn: getStaleOrdersDates,
    staleTime: 5 * 60 * 1000, // 5 minutes — the daily report changes at most once/day
  });
}

export function useStaleOrders(date: string | undefined) {
  return useQuery({
    queryKey: ['stale-orders', date],
    queryFn: () => getStaleOrders(date as string),
    enabled: !!date,
    staleTime: 60 * 1000,
  });
}
